export default "__VITE_ASSET__bo$HyfYQ__"